declare global {
	const GlobalSearchLabels: {
		FreeTextQuery: string,
		Operator: string,
		AndOperator: string,
		OrOperator: string,
		NotOperator: string,
		LeftParenOperator: string,
		RightParenOperator: string,
		FreeText: string,
		Descriptor: string,
		Synonym: string,
		Category: string,
		TextSearch: string,
		Vocabulary: string,
		CompleteVocabulary: string,
		Done: string,
		SeeDetails: string,
		MainTopicName: string,
		Synonyms: string,
		ThereAreNoSynonyms: string,
		ThisTermIsDeprecated: string
	};
}

export default class GlobalSearchState {

	searchMode = GlobalSearchMode.Default;
	userSearchMode: GlobalSearchMode;

	contentSearchBlockList: ContentSearchBlock[] = [];
	vocabColorPalette: VocabColorPalette[];
	vocabularies: SemanticVocabulary[];
	descriptors: SemanticDescriptor[];

	selectedSideItemValue: MultiSearch;
	noSearchSwitcher = true;

	noSearchButton = false;
	noPreviousSearches = false;
	noAdvancedSearch = false;
	isAdvancedSearchMode = false;
	searchScope: GlobalSearchScope = GlobalSearchScope.Global;

	allowEmptySearch = false;
	emptyMessage = "";
	emptyMessageContinueEditing = "";
	advancedSearchButtonText = "";

	abortLookup = false;
	lookupsAlways = true;

	handlers: GlobalSearchHandlers;

	searchBlockOperators: SearchBlockOperator[] = [];

	static blockDelim = "\x01";
	static propDelim = "\x02";

	static andOperatorText = "AND";
	static orOperatorText = "OR";
	static notOperatorText = "NOT";
}

export interface GlobalSearchHandlers {
	readonly executeSearch: () => void;
	readonly sideItemChanged: (value: MultiSearch) => void;
	readonly advancedSearch: () => void;
	readonly clearResult?: () => void;
}

export enum GlobalSearchMode {
	Default = 0,
	FullText = 1,
	SemanticSearch = 2
}

export enum SearchBlockType {
	FreeText = 0,
	Synonym = 1,
	Descriptor = 2,
	Vocab = 3,
	Operator = 4
}

export enum SearchBlockOpType {
	Unknown = -1,
	AND = 0,
	OR = 1,
	NOT = 2,
	LeftParens = 3,
	RightParens = 4
}

export enum MultiSearch {
	CCC = "CCC",
	EDS = "EDS"
}

export enum KeyCode {
	ArrowUp = "ArrowUp",
	ArrowDown = "ArrowDown",
	ArrowLeft = "ArrowLeft",
	ArrowRight = "ArrowRight",
	TAB = "Tab",
	Enter = "Enter",
	DEL = "Delete",
	Backspace = "Backspace",
	Escape = "Escape"
}

// id: string;
export interface ContentSearchBlock {
	type: SearchBlockType;
	text: string;
	synName?: string;
	descriptorName?: string;
	opType: SearchBlockOpType;
	vocab?: string;
	descriptor?: ContentSearchDescriptor;
	invalid?: boolean;
}

export interface ContentSearchDescriptor {
	readonly vocabularyId: number;
	readonly descriptorId: number;
}

export interface SearchBoxSideItem {
	readonly text: string;
	readonly value: string;
}

export interface SemanticVocabulary {
	readonly name: string;
	readonly Id: number;
	readonly displayName: string;
	readonly description: string;
	readonly semanticEngineId: number;
	readonly semanticEngineName: string;
}

export interface SemanticDescriptor {
	readonly id: number;
	readonly name: string;
}

export interface SearchBlockOperator {
	name: string;
	type: SearchBlockOpType;
	jsEquivalent: string;
	special: boolean;
	text: string;
}

export interface VocabColorPalette {
	readonly UnselectedBar: string;
	readonly SelectedBar: string;
	readonly Highlight: string;
	readonly Hover: string;
}

export interface QueryResult {
	readonly Id?: number;
	readonly DisplayName: string;
	readonly Description?: string;
	readonly Name: string;
	readonly SynName: string;
	readonly Synonyms?: string[];
	readonly Type: number;
	readonly Value: string;
	readonly Vocab: string;
	readonly VocabularyId: number;
	readonly DescriptorId: number;
}

export interface TooltipParent {
	readonly container: JQuery;
	getTooltipInfo(): JQuery;
	getTooltipInfoExtended(): [JQuery, JQuery];
}

export enum GlobalSearchScope {
	Global = 0,
	MyLibrary = 1
}

export const GlobalSearchScopeName = {
	[GlobalSearchScope.Global]: 'global',
	[GlobalSearchScope.MyLibrary]: 'mylibrary'
};
